var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2020_1391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5829 5.4224C19.4696 5.01843 19.249 4.65269 18.9445 4.36407C18.6314 4.06657 18.2477 3.85376 17.8295 3.74573C16.2645 3.33323 9.99454 3.33323 9.99454 3.33323C7.38065 3.30349 4.7674 3.4343 2.16954 3.7249C1.75136 3.84091 1.36834 4.05847 1.05454 4.35823C0.746204 4.6549 0.522871 5.02073 0.406204 5.42157C0.125949 6.93135 -0.0102189 8.46435 -0.000462243 9.9999C-0.0104622 11.5341 0.125371 13.0666 0.406204 14.5782C0.520371 14.9774 0.742871 15.3416 1.05204 15.6357C1.3612 15.9299 1.7462 16.1424 2.16954 16.2549C3.75537 16.6666 9.99454 16.6666 9.99454 16.6666C12.6118 16.6963 15.2283 16.5655 17.8295 16.2749C18.2477 16.1669 18.6314 15.9541 18.9445 15.6566C19.2489 15.368 19.4693 15.0022 19.582 14.5982C19.8696 13.089 20.0094 11.5554 19.9995 10.0191C20.0212 8.47624 19.8815 6.93537 19.5829 5.42157V5.4224ZM8.0012 12.8532V7.1474L13.2179 10.0007L8.0012 12.8532Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2020_1391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.d34f457e94397c62e99e21916284f5e0.svg";
export { ForwardRef as ReactComponent };